import { getFirestore, collection, query, where, orderBy, getDocs, getDoc, doc } from "firebase/firestore";
import { firebaseApp } from "../../firebase.js"; // adjust based on where you init Firebase

const db = getFirestore(firebaseApp);

function shuffleArray(array) {
  return array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

const getUserByRef = async (userRef) => {
  if (!userRef) return null;
  const userSnap = await getDoc(userRef);
  return userSnap.exists() ? { id: userSnap.id, ...userSnap.data() } : null;
};


export const getApprovedRentalsWithUser = async () => {
  const q = query(
    collection(db, "Rental"),
    where("status", "==", "Approve"),
    orderBy("CreatedTime", "desc")
  );

  const snapshot = await getDocs(q);
  const rentals = await Promise.all(
    snapshot.docs.map(async (docSnap) => {
      const rentalData = docSnap.data();
      const user = await getUserByRef(rentalData.employerUID);
      return {
        id: docSnap.id,
        ...rentalData,
        employerUser: user, // add full user data
      };
    })
  );

  return rentals;
}

export const getRentalById = async (id) => {
  try {
    const docRef = doc(db, "Rental", id);      // <-- Use modular doc() here
    const docSnap = await getDoc(docRef);     // <-- Use getDoc()

    if (!docSnap.exists()) return null;       // <-- call exists() as a method

    const rentalData = docSnap.data();
    const user = await getUserByRef(rentalData.employerUID);    
    return {
      id: docSnap.id,
      ...rentalData,
      employerUser: user
    };
  } catch (error) {
    console.error("Error fetching rental by ID:", error);
    return null;
  }
};

export const getRandomApprovedRentalsWithUser = async () => {
  const q = query(
    collection(db, "Rental"),
    where("status", "==", "Approve"),
    orderBy("CreatedTime", "desc")
  );

  const snapshot = await getDocs(q);

  const shuffledDocs = shuffleArray(snapshot.docs).slice(0, 5);

  const rentals = await Promise.all(
    shuffledDocs.map(async (docSnap) => {
      const rentalData = docSnap.data();
      const user = await getUserByRef(rentalData.employerUID);
      return {
        id: docSnap.id,
        ...rentalData,
        employerUser: user,
      };
    })
  );

  return rentals;
};

export const getLoginUserRental = async (userData) =>{
try {
    if (!userData) return []; // not logged in

    // query rentals owned by the logged-in user
    const q = query(
      collection(db, "Rental"),
      where("employerUID", "==", doc(db, "Users", userData.uid)), // employerUID is a DocumentReference
      orderBy("CreatedTime", "desc")
    );

    const snapshot = await getDocs(q);

    const rentals = await Promise.all(
      snapshot.docs.map(async (docSnap) => {
        const rentalData = docSnap.data();

        // query the subcollection "orders" inside this rental doc
        const ordersRef = collection(db, "Rental", docSnap.id, "orders");
        const ordersQuery = query(ordersRef, orderBy("startDate", "asc"));
        const ordersSnap = await getDocs(ordersQuery);

        const orders = ordersSnap.docs.map((orderDoc) => ({
          id: orderDoc.id,
          ...orderDoc.data(),
        }));

        return {
          id: docSnap.id,
          ...rentalData,
          employerUser: userData,
          orders: orders,
        };
      })
    );
    return rentals;
  } catch (error) {
    console.error("Error fetching rentals for logged-in user:", error);
    return [];
  }
}
